import { render, staticRenderFns } from "./detailBtn.vue?vue&type=template&id=434a6a7c&scoped=true"
import script from "./detailBtn.vue?vue&type=script&lang=js"
export * from "./detailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a6a7c",
  null
  
)

export default component.exports